import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../css/TopBar.css";
import { useDispatch, useSelector } from "react-redux";
import { setSearchTerm } from "../redux/chatSlice";
import sharIcon from "../assets/icons/sharesvg.png";
import profileIcon from "../assets/icons/profileIcon.png";
import settingIcon from "../assets/icons/settingIcon.png";
import helpIcon from "../assets/icons/helpIcon.png";
import logoutIcon from "../assets/icons/logoutIcon.png";
import crossIcon from "../assets/icons/crossIcon.png";
import mailIcon from "../assets/icons/mailIcon.png";
import api from "../api";
// import { fetchUnreadCount } from "../redux/notificationSlice";
import {
  resetSidebarState,
  setSelectedMenu,
  setRefreshSidebar,
} from "../redux/sidebarSlice";

const TopBar = ({ sidebarExpanded, toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profileMenuRef = React.useRef(null);

  const [models, setModels] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [showTooltip, setShowTooltip] = useState(null);
  const reversedModelList = modelList.slice().reverse();

  const selectedModel = useSelector((state) => state.model.selectedModel);
  // const selectedMode = useSelector((state) => state.model.selectedMode);
  const sessionId = useSelector((state) => state.session.sessionId);
  const { isChatPage } = useSelector((state) => state.session);

  const [showShareModal, setShowShareModal] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [copyStatus, setCopyStatus] = useState("idle");
  const [showMailIcon, setShowMailIcon] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showModelConfirmation, setShowModelConfirmation] = useState(false);
  const [selectedModelDetails, setSelectedModelDetails] = useState(null);
  // const [notifications, setNotifications] = useState([]);
  // const unreadCount = useSelector((state) => state.notifications.unreadCount);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [user, setUser] = useState(null);
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);
  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );

  const handleSearchChange = (e) => {
    dispatch(setSearchTerm(e.target.value));
  };

  const handleLogout = async () => {
    try {
      // ✅ Call backend logout API
      await api.post(
        `${process.env.REACT_APP_API_URL}/auth/logout-device`,

        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // ✅ Clear localStorage & sessionStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("api_key");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api_key");

      // ✅ Reset Redux / UI state
      dispatch(resetSidebarState());

      // ✅ Redirect to login page
      navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
      // Optional: show toast/error notification to user
    }
  };

  const handleShareSession = async () => {
    if (!sessionId) return console.log("Session ID not available!");

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/chat/share-session`,
        { session_id: sessionId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const shareURL = `${process.env.REACT_APP_API}/chat/shared/${sessionId}`;
      setGeneratedLink(shareURL);
      setShowShareModal(true);
    } catch (error) {
      console.error("Error sharing session", error);
      alert("❌ Failed to share session");
    }
  };

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      localStorage.setItem("darkMode", newMode);
      document.documentElement.setAttribute(
        "data-theme",
        newMode ? "dark" : "light"
      );
      return newMode;
    });
  };

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light"
    );
  }, [darkMode]);

  const toggleProfileMenu = () => {
    setShowProfileMenu((prev) => {
      if (!prev) {
        // Opening → add outside click listener
        document.addEventListener("mousedown", handleOutsideClick);
      } else {
        // Closing → remove listener
        document.removeEventListener("mousedown", handleOutsideClick);
      }
      return !prev;
    });
  };

  const handleOutsideClick = (event) => {
    if (
      profileMenuRef.current &&
      !profileMenuRef.current.contains(event.target)
    ) {
      setShowProfileMenu(false);
      document.removeEventListener("mousedown", handleOutsideClick);
    }
  };

  const closeMenu = () => {
    setShowProfileMenu(false);
    document.removeEventListener("mousedown", handleOutsideClick);
  };

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  useEffect(() => {
    const dropdowns = document.querySelectorAll(".dropdown-toggle");

    dropdowns.forEach((btn) => {
      btn.addEventListener("click", () => {
        dropdowns.forEach((otherBtn) => {
          if (otherBtn !== btn) {
            const menu = otherBtn.nextElementSibling;
            if (menu && menu.classList.contains("show")) {
              menu.classList.remove("show");
            }
          }
        });
      });
    });

    return () => {
      dropdowns.forEach((btn) => {
        btn.removeEventListener("click", () => {});
      });
    };
  }, []);

  // ✅ Fetch user profile from API
  useEffect(() => {
    const token1 = sessionStorage.getItem("access_token");

    const fetchUserProfile = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/user-profile/profile`,
          {
            headers: { Authorization: `Bearer ${token1}` },
          }
        );

        setUser(res.data);

        // console.log(res.data.role_name)
        localStorage.setItem("role_name", res.data.role_name);
        sessionStorage.setItem("role_name", res.data.role_name);
      } catch (err) {
        console.error("Failed to fetch user profile:", err);
      }
    };

    if (token) fetchUserProfile();
  }, [token]);

  return (
    <div>
      <nav className="navbar navbar-expand-lg px-3 shadow-sm d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-1 justify-content-between w-100">
          <div className="d-md-none me-3">
            <button className="btn p-0 border-0" onClick={toggleSidebar}>
              <i className="bi bi-list fs-3 textblack"></i>
            </button>
          </div>

          <h4 className="m-0 refresh-prompts fw-bold">{selectedMenu}</h4>

          {/* 🔍 Search */}
          {isChatPage && (
            <div className="custom-search-wrapper w-50 m-auto">
              <div className="input-group custom-search-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search For Chats"
                  onChange={handleSearchChange}
                />
              </div>
            </div>
          )}

          {/* Icons */}
          <div className="d-flex align-items-center gap-3 ms-auto position-relative">
            {isChatPage && sessionId && (
              <img
                className="icon-image"
                onClick={handleShareSession}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
                src={sharIcon}
                alt="share"
              />
            )}

            {/* <Link
              to="notifications"
              className="btn  textblack hi p-0 position-relative"
            >
              <i className="bi bi-bell"></i>
              {unreadCount > 0 && (
                <span
                  style={{ fontSize: "8px" }}
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                >
                  {unreadCount}
                </span>
              )}
            </Link> */}

            {/* <div className="d-flex align-items-center gap-3 ms-auto position-relative">
   
              <ModeSelector />
            </div> */}

            <button
              className="border-0"
              onClick={toggleDarkMode}
              title="Toggle Theme"
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                backgroundColor: "#212529",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0",
              }}
            >
              <i
                className={`bi ${darkMode ? "bi-moon" : "bi-sun"} textwhite`}
                style={{ fontSize: "15px" }}
              />
            </button>

            <div className="position-relative" ref={profileMenuRef}>
              <button
                className="p-0 border-0 bg-transparent"
                onClick={toggleProfileMenu}
              >
                {user?.user_profile_pic ? (
                  <img
                    src={`${
                      process.env.REACT_APP_SERVER_URL
                    }/${user.user_profile_pic.replace(/\\/g, "/")}`}
                    alt="Profile"
                    className="rounded-circle"
                    style={{
                      width: "28px",
                      height: "28px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    className="rounded-circle bg-dark border border-1 text-white d-flex align-items-center justify-content-center"
                    style={{ width: "28px", height: "28px", fontSize: "12px" }}
                  >
                    {user?.user_name?.charAt(0).toUpperCase() || "U"}
                  </div>
                )}
              </button>

              {showProfileMenu && (
                <div
                  className="dropdown-menu show profile-dropdown"
                  onMouseLeave={closeMenu} // Close on mouse leave
                >
                  {/* ✅ User Email at Top */}
                  <div className="dropdown-header d-flex align-items-center">
                    <img
                      src={profileIcon}
                      alt="Profile"
                      className="Profile-Svg icon-image"
                    />
                    <span className="Profile-text refresh-prompts email-text">
                      {user?.user_email || "User"}
                    </span>
                  </div>

                  {/* ✅ Settings */}
                  <Link
                    className="dropdown-item profile-dropdown-item gap-2 d-flex align-items-center"
                    to="profile"
                    onClick={closeMenu} // 🔹 Close after click
                  >
                    <img
                      src={settingIcon}
                      alt="Settings"
                      className="Profile-Svg icon-image"
                    />
                    <span className="Profile-text">Settings</span>
                  </Link>

                  {/* ✅ Notifications */}
                  {/* <Link
                    className="dropdown-item profile-dropdown-item gap-2 d-flex align-items-center position-relative"
                    to="notifications"
                    onClick={closeMenu} // 🔹 Close after click
                  >
                    <i className="bi bi-bell"></i>
                    <span className="Profile-text">Notifications</span>
                    {unreadCount > 0 && (
                      <span className="notification-badge">{unreadCount}</span>
                    )}
                  </Link> */}

                  {/* ✅ Help */}
                  <Link
                    className="dropdown-item profile-dropdown-item gap-2 d-flex align-items-center"
                    to="getHelp"
                    onClick={closeMenu} // 🔹 Close after click
                  >
                    <img
                      src={helpIcon}
                      alt="Help"
                      className="Profile-Svg icon-image"
                    />
                    <span className="Profile-text">Get Help</span>
                  </Link>

                  {/* ✅ Logout */}
                  <button
                    className="dropdown-item profile-dropdown-item gap-2 d-flex align-items-center"
                    onClick={() => {
                      handleLogout();
                      closeMenu(); // 🔹 Close after logout
                    }}
                  >
                    <img
                      src={logoutIcon}
                      alt="Logout"
                      className="Profile-Svg icon-image"
                    />
                    <span className="Profile-text">Logout</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Share Modal */}
      {showShareModal && (
        <div className="modal-backdrop-custom">
          <div className="share-modal position-relative">
            <img
              src={crossIcon}
              alt="Close"
              className="custom-close-icon icon-image"
              onClick={() => {
                setShowShareModal(false);
                setShowMailIcon(false);
                setCopyStatus("idle");
              }}
            />
            <h5 className="mb-4 refresh-prompts mt-4">
              Share your conversation
            </h5>
            <button
              className="rounded share-button w-100 mb-4 d-flex justify-content-center align-items-center fw-semibold p-1"
              onClick={async () => {
                if (copyStatus === "copied") return;
                setCopyStatus("copying");
                await navigator.clipboard.writeText(generatedLink);
                setCopyStatus("copied");
                setShowMailIcon(true);
              }}
              disabled={
                !generatedLink ||
                copyStatus === "copying" ||
                copyStatus === "copied"
              }
            >
              <span
                className="spinner-container"
                style={{ width: "16px", height: "16px" }}
              >
                {copyStatus === "copying" && (
                  <span className="spinner-border spinner-border-sm textwhite" />
                )}
              </span>
              <span>
                {copyStatus === "copied"
                  ? "Link Copied!"
                  : copyStatus === "copying"
                  ? "Copying..."
                  : "Copy Link"}
              </span>
            </button>
            {showMailIcon && (
              <div className="share-mail-icon">
                <img
                  src={mailIcon}
                  alt="Send via Email"
                  title="Send via Email"
                  style={{ width: "30px", height: "30px", cursor: "pointer" }}
                  onClick={() => {
                    const mailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Chat Session Link&body=Here is the session link: ${generatedLink}`;
                    window.open(mailURL, "_blank");
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {showModelConfirmation && selectedModelDetails && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content w-50 mx-auto">
              {/* Close Button */}
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => setShowModelConfirmation(false)}
                aria-label="Close"
              >
                <img src={crossIcon} className="icon-image" alt="Close" />
              </button>

              {/* Modal Body */}
              <div className="text-center">
                <p className="fw-bold mt-2 mb-3 refresh-prompts">
                  Excellent choice! This model delivers high performance for
                  similar tasks.
                </p>

                <div className="border rounded-3 p-3 mt-3 text-start">
                  <p
                    className="text-truncate mb-2 refresh-prompts"
                    title={
                      selectedModelDetails.name ||
                      selectedModelDetails.model_generic_name
                    }
                  >
                    <strong className="refresh-prompts">Model Name: </strong>
                    {selectedModelDetails.name ||
                      selectedModelDetails.model_generic_name}
                  </p>

                  <hr className="my-2" />

                  <p
                    className="text-truncate mb-2 refresh-prompts"
                    title={selectedModelDetails.model_industry || "N/A"}
                  >
                    <strong className="refresh-prompts">Industries: </strong>
                    {selectedModelDetails.model_industry || "N/A"}
                  </p>

                  <hr className="my-2" />

                  <p className="fw-bold mt-3 mb-2 refresh-prompts">
                    Description:
                  </p>
                  <p
                    title={
                      selectedModelDetails.model_user_description ||
                      "No description available."
                    }
                    className="refresh-prompts model-d"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 5,
                      WebkitBoxOrient: "vertical",
                      textAlign: "justify",
                      height: "90px",
                      overflowY: "scroll",
                      // textOverflow: "ellipsis",
                    }}
                  >
                    {selectedModelDetails.model_user_description ||
                      "No description available."}
                  </p>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="px-5 rounded custom-btn border-none py-2 fw-bold refresh-prompts"
                  onClick={() => setShowModelConfirmation(false)}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBar;
